import React from "react";
import pivas_bgc from "../assets/images/pivas_bgc.jpg";
import logo from "../assets/images/szwj-logo.png";
// import white_byj from "../assets/images/white_byj.jpg";
import white_3ufjj from "../assets/images/white_3ufjj.jpg";
import white_tqj from "../assets/images/white_tqj.jpg";
import software from "../assets/images/software.jpg";
const ArticleDetails = () => {
  return (
    <section className="blog-details" >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="blog-one__single">
              <div className="blog-one__image2">
                <img src={pivas_bgc} alt="" />
              </div>
              <div className="blog-one__content ">
                <h2 className="blog-one__title text-center">
                关于我们
                </h2>
                <p className="blog-one__text "style={{color:"black"}}>
                   苏州卫捷医药科技有限公司是专注于医院自动化领域软硬件系统开发的高科技企业，致力于将全球最新的通信与控制自动化技术应用于中国医疗行业。公司聚集了众多在数字信息和机器人自动化领域拥有丰富经验的全球高端优秀人才。
                </p>
                <p className="blog-one__text" style={{color:"black"}}>公司成功开发并广泛实施医院静脉配置中心软硬件整体解决方案、院内中型物流传输系统，自动化射频扫描终端等现代化医院的必备产品。将云计算技术、海量数据处理能力整合应用，全面提升医院静脉用药集中调配中心（PIVAS）的信息化、智能化、自动化水平，全面优化静脉用药集中调配中心的工作流程，大幅提升静脉用药集中调配中心的工作效率和准确率，全面降低药师工作压力和劳动强度，通过其具有独立知识产权的PIVAS全流程相关软硬件，系统性提升PIVAS各个工序的质量控制，简化相关流程，避免各环节的重复劳动，使医院静脉用药更安全更合理，提升医院药学服务水平。</p>
                <p className="blog-one__text" style={{color:"black"}}>苏州卫捷长期专注于PIVAS新产品研发和设备产品的升级，是业界为数不多能完成静脉用药调配中心整体规划方案布局、整体装修、核心设备安装、辅助设备调试、PIVAS整体运作流程的记录及信息追溯等综合解决方案的企业。</p>               
              </div>
            </div>
          
          
            <div className="blog-one__single blog-details__author">
              <div className="">
                
                <h2 className="blog-one__title text-center">
                发展历程
                </h2>
                <img src={white_3ufjj} alt="" style={{width:"100%"}}/>
                <p className="blog-one__text"style={{color:"black"}}>
                2014年底全球第一台静配用药智能分拣系统于苏州卫捷医药科技有限公司研发问世，2015年元旦第一台成品机器安装实施于天津医科大学总院，使用后彻底解决了静脉用药集中调配中心最大的错误产生源，实现了成品输液准确、高效的发放，第一时间送至病房。
                </p>
                <p className="blog-one__text">                  
                </p>
                <img src={white_tqj} alt="" style={{width:"100%"}}/>
                <p className="blog-one__text"style={{color:"black"}}>
                2016年初全球第一台静配用药智能贴签系统于苏州卫捷医药科技有限公司研发问世，2016年8月第一台成品安装实施于安徽淮北矿工总医院，使用后彻底解决了静脉用药集中调配中心溶媒标签不平配问题，保证用药的安全。
                </p>
                <p className="blog-one__text">                  
                </p>
                <img src={software} alt=""style={{width:"100%"}}/>
                <p className="blog-one__text"style={{color:"black"}}> 
                2019年为了将PIVAS（静脉用药调配中心）日常琐碎的工作标准化、规范化和信息化，提高药学服务于临床的能力，苏州卫捷通过无线网络技术、二维码技术、手持PDA设备和日常办公电脑等手段建立了“PIVAS全流程质控系统”，完成了包括智能化的信息采集、存储和分析利用，实现PIVAS质控的统一化、智能化。
                </p>
              </div>
            </div>
 
           <div className="share-block">
              <div className="left-block" style={{fontSize:"24"}}>
                <p>
                  企业价值观: <a href="#none">理想</a>{" "}
                  <a href="#none">担当,</a> <a href="#none">坚持</a><a href="#none">分享</a><a href="#none">尊重</a>
                </p>
              </div>
              <div className="social-block">
              </div>
            </div>
 
            <div className="blog-details__author">
              <div className="blog-details__author-image">
                <img src={logo} alt="" />
              </div>
              <div className="blog-details__author-content">
                <h3>苏州卫捷医药科技有限公司</h3>
                <p>苏州卫捷医药科技有限公司专注于医院自动化领域软硬件系统开发的高科技企业,致力于将全球最新的通信与控制自动化技术应用于中国医疗行业。公司将最先进的信息智能技术应用于临床管理，荣获国家发明专利近百项，实现人类医疗和健康的信息化和智能化。</p>
              </div>
            </div>
         </div>
</div>
      </div>
    </section>
  );
};

export default ArticleDetails;
